import { IApiRequestConfig } from '../api.types';
import { IWrikeSyncPair } from '../../resource/wrike-folder/wrike-folder.types';
import { IWrikeFoldersParams } from '../../page/page-storage/wrike/wrike.types';

export const integrateWrikeApi = (code: string, state: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'integrateWrike',
  action: 'wrike/integrate',
  method: 'get',
  params: {
    code,
    state,
  },
  v2: true,
});

export const getWrikeFoldersApi = (params?: IWrikeFoldersParams): IApiRequestConfig<IWrikeFoldersParams> => ({
  apiRouteKey: 'getWrikeFolders',
  action: 'wrike/folders',
  method: 'get',
  params,
  v2: true,
});

export const syncWrikeFoldersApi = (data: IWrikeSyncPair): IApiRequestConfig<IWrikeSyncPair> => ({
  apiRouteKey: 'syncWrikeFolders',
  action: 'wrike/sync-folders',
  method: 'post',
  data,
  v2: true,
});

export const fetchWrikeFolderMeetingsApi = (): IApiRequestConfig => ({
  apiRouteKey: 'fetchWrikeFolderMeetings',
  action: 'wrike/folder-meetings',
  method: 'get',
  v2: true,
});

export const removeWrikeIntegrationApi = (): IApiRequestConfig => ({
  apiRouteKey: 'removeWrikeIntegration',
  action: 'wrike/integration',
  method: 'delete',
  v2: true,
});
